<template>
  <div id="articleStatic">
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ data.title || "板块介绍" }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card table" shadow="never">
      <el-form :model="data" ref="ruleForm" label-width="100px" class="demo-ruleForm"
        @submit.native.prevent="save('ruleForm')">
        <el-form-item label="标题" prop="title" :rules="[{ required: true, message: '请输入标题' }]">
          <el-input v-model="data.title" placeholder="板块标题"></el-input>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="data.summary" placeholder="首页展示摘要"></el-input>
        </el-form-item>
        <el-form-item label="封面图">
          <div :id="uploadBtnId" class="uploader uploader-warning"></div>
          <img v-if="data.imgUrl" :src="domain + data.imgUrl" style="height: 50px; margin-left: 10px" />
          <div class="uploader-text">小程序首页板块封面（入口图标用，支持 gif 动图）</div>
        </el-form-item>
        <el-form-item label="业务介绍" prop="content" :rules="[{ required: true, message: '请输入内容' }]">
          <!-- 切换板块时强制重建编辑器，避免工具栏图片/视频上传失效 -->
          <vue-ueditor-wrap
            v-if="editorReady"
            :key="'ue-' + articleId"
            v-model="data.content"
            :config="editorConfig"
          ></vue-ueditor-wrap>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" native-type="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  name: "articleStatic",
  components: { VueUeditorWrap },
  data() {
    return {
      loading: false,
      domain: url.getDomain(),
      articleId: 0,
      editorReady: false,
      data: {
        id: 0,
        title: "",
        summary: "",
        imgUrl: "",
        content: "",
      },
      editorConfig: {
        serverUrl: url.getUE(),
        UEDITOR_HOME_URL: url.getUEConfig(),
        initialFrameWidth: "100%",
        initialFrameHeight: 500,
      },
    };
  },
  computed: {
    uploadBtnId() {
      return "uploadArticleStatic_" + (this.articleId || "0");
    },
  },
  methods: {
    get() {
      var _this = this;
      var id = parseInt(this.$route.params.id, 10) || 0;
      this.articleId = id;
      this.editorReady = false;
      if (!id) {
        this.$message({ type: "error", message: "无效的板块 ID" });
        return;
      }
      var link = url.getSys("get_articleStatic");
      $.get(link, { id: id }, (res) => {
        if (!res || !res.id) {
          _this.$message({ type: "error", message: "文章不存在，请检查菜单链接 ID" });
          _this.data = { id: id, title: "", summary: "", imgUrl: "", content: "" };
          return;
        }
        _this.data = {
          id: res.id,
          title: res.title || "",
          summary: res.summary || "",
          imgUrl: res.imgUrl || "",
          content: res.content || "",
        };
        _this.editorReady = true;
        _this.$nextTick(() => _this.initUploader());
      }).fail(function () {
        _this.$message({ type: "error", message: "加载失败" });
      });
    },
    initUploader() {
      var _this = this;
      var sel = "#" + this.uploadBtnId;
      var $el = $(sel);
      if (!$el.length) return;
      // 切换 /articleStatic/:id 时同组件复用，必须清空后重建，否则按钮空白或回调错乱
      $el.empty();
      $el.uploader({
        url: url.getUpload(),
        text: "上传封面",
        type: "single",
        fileExts: "jpg;png;gif;webp",
        handleType: "0",
        maxSize: 1024 * 1024 * 3,
        onSuccess(data) {
          _this.$set(_this.data, "imgUrl", data.relativeName);
        },
      });
    },
    save(formName) {
      var _this = this;
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        if (!_this.data.id) {
          _this.$message({ type: "error", message: "文章不存在，无法保存" });
          return false;
        }
        var link = url.getSys("save_articleStatic");
        _this.loading = true;
        $.post(link, _this.data, (res) => {
          _this.loading = false;
          if (res.status) {
            _this.$message({ type: "success", message: "保存成功！" });
          } else {
            _this.$message({ type: "error", message: res.msg || "保存失败" });
          }
        }).fail(function () {
          _this.loading = false;
          _this.$message({ type: "error", message: "保存请求失败" });
        });
      });
    },
  },
  created() {
    this.get();
  },
  watch: {
    "$route.params.id"() {
      this.get();
    },
  },
};
</script>
